var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.28 22.32L25.68 0.72C24.7201 -0.24 23.28 -0.24 22.32 0.72L0.72 22.32C-0.24 23.28 -0.24 24.7201 0.72 25.68L22.32 47.28C23.28 48.24 24.7201 48.24 25.68 47.28L47.28 25.68C48.24 24.7201 48.24 23.2801 47.28 22.32ZM28.8 30.0001V24.0001H19.2V31.2001H14.4V21.6001C14.4 20.1601 15.36 19.2001 16.8 19.2001H28.8V13.2001L37.2 21.6001L28.8 30.0001Z",
    fill: "#1375ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav);
export default __webpack_public_path__ + "static/media/icon_nav.bd99429e7349aa55fb01ff3406254287.svg";
export { ForwardRef as ReactComponent };